import { ref } from 'vue'

export const refreshOverviewCallback = ref<Function>()
